import PropTypes from 'prop-types';

const propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

function Contact({ children, className = '' }) {
  return (
    <div className={`footer__contact ${className}`.trim()}>
      <div>
        {children}
      </div>
    </div>
  );
}

Contact.propTypes = propTypes;

export default Contact;

// Copyright © 2025 Micruity Inc.
